import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { RestApi } from 'src/app/shared/RestApi/restApi';
import { CommonService } from 'src/app/shared/services/common.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { trnxCommonServiceInfo } from 'src/app/shared/services/reporttemplate.service';

@Component({
    selector: 'app-password-configuration-pop-up',
    templateUrl: './password-configuration-pop-up.component.html',
    styleUrls: ['./password-configuration-pop-up.component.scss'],
    standalone: false
})
export class PasswordConfigurationPopUpComponent implements OnInit {
 private headers = new HttpHeaders({ "Content-Type": "application/json" });
   backgroundColorButton: string;
    backgroundColorScreen: any;
      FormValid: UntypedFormGroup;
      validation_messages: any;
    passwordPolicy={
      id:0,disableallrules:false,resetlimit:null,lastpasswordchecking:null,passwrodcomparisionwithusername:"",
      duplicatepassord:"",expirydate:"",expiry:"",containsUsername:"",lockoutvalue:null,lockoutUnit:null,lockoutenabled:null,
      passwordexpirycycle:"",companyname:""
    }
  isEditMode: boolean = false; 
  buttonName: string;
  companyData: any;
  userRoleNameData: any;
  // errorMsg: any;

  
    constructor( private localStorageSettings: LocalStorageSettingsService, private spinner: NgxUiLoaderService,
        private snackBar: MatSnackBar,private dialog: MatDialog,private commonService:CommonService, public dialogref: MatDialogRef<PasswordConfigurationPopUpComponent>,
       @Inject(MAT_DIALOG_DATA) public data: any, private fb: FormBuilder,private errorMsg: ErrorMessages,private restAPI: RestApi,private http: HttpClient) {
         this.validation_messages = this.errorMsg.passwordPolicies;
        }
  
    ngOnInit(): void {
       this.formvalidations()
       this.DropdownCompany()
       this.validations()
       if(!this.data?.edata){
          this.FormValid.patchValue({
            resetlimit: 5,
            lastpasswordchecking: 5,
            lockoutenabled: true,
            lockoutvalue:2,
            lockoutUnit:'MINUTES',
            passwordexpirycycle:90
          })
       }
      if (this.data && this.data.edata) {
          console.log("inside update")
        this.isEditMode = true;
        this.buttonName = "Update"
        this.data.edata.passwrodcomparisionwithusername =
       this.data. edata.passwrodcomparisionwithusername === true ||
        this.data. edata.passwrodcomparisionwithusername === 'true';
        this.passwordPolicy = { ...this.passwordPolicy, ...this.data.edata };
        this.FormValid.patchValue(this.data.edata);
      }else{
        this.buttonName = "Save"
     }
       this.backgroundColorButton = this.localStorageSettings.getSettings('ColorA');
       this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
        // this.formvalidations()
    }

   formvalidations() {
  this.FormValid = new UntypedFormGroup({
    disableallrules: new UntypedFormControl(false),
    resetlimit: new UntypedFormControl('', [Validators.min(5)]),
    lastpasswordchecking: new UntypedFormControl('', [Validators.min(5)]),
    lockoutvalue: new UntypedFormControl('', [Validators.min(1)]),
    lockoutenabled: new UntypedFormControl(false), 
    lockoutUnit: new UntypedFormControl(null),       
    passwrodcomparisionwithusername: new UntypedFormControl(false), // <-- to avoid nulls
    duplicatepassord: new UntypedFormControl(''),
    passwordexpirycycle: new UntypedFormControl('',[Validators.min(30)]),
    companyname:new UntypedFormControl('',Validators.required)
  });
}

validations(){
    // React to disableallrules
  this.FormValid.get('disableallrules')?.valueChanges.subscribe((disabled: boolean) => {
    if (disabled) {
      this.FormValid.get('resetlimit')?.disable();
      this.FormValid.get('lastpasswordchecking')?.disable();
      this.FormValid.get('passwrodcomparisionwithusername')?.disable();
      this.FormValid.get('duplicatepassord')?.disable();
      this.FormValid.get('lockoutenabled')?.disable();
      this.FormValid.get('lockoutvalue')?.disable();
      this.FormValid.get('lockoutUnit')?.disable();
    } else {
      this.FormValid.get('resetlimit')?.enable();
      this.FormValid.get('lastpasswordchecking')?.enable();
      this.FormValid.get('passwrodcomparisionwithusername')?.enable();
      this.FormValid.get('duplicatepassord')?.enable();
      this.FormValid.get('lockoutenabled')?.enable();
      // lockoutvalue & unit only if lockoutenabled is true
      if (this.FormValid.get('lockoutenabled')?.value) {
        this.FormValid.get('lockoutvalue')?.enable();
        this.FormValid.get('lockoutUnit')?.enable();
      }
      this.FormValid.get('passwordexpirycycle')?.enable();
    }
    });

  // React to lockoutenabled to show/hide lockout fields
  this.FormValid.get('lockoutenabled')?.valueChanges.subscribe((enabled: boolean) => {
    if (enabled && !this.FormValid.get('disableallrules')?.value) {
      this.FormValid.get('lockoutvalue')?.enable();
      this.FormValid.get('lockoutUnit')?.enable();
    } else {
      this.FormValid.get('lockoutvalue')?.disable();
      this.FormValid.get('lockoutUnit')?.disable();
    }
  });
}


  openSaveForm(){
      // Get form values
  const formValue = this.FormValid.value;
    console.log(formValue)
  
 // Rule: if resetlimit > 0 → lockout must be enabled and required fields present
  // if (formValue.resetlimit > 0) {
  //   if (!formValue.lockoutenabled) {
  //     this.snackBar.open('Lockout must be enabled when Reset Limit is greater than 0', 'OK', { duration: 5000 });
  //     return;
  //   }

  //   if (!formValue.lockoutvalue || formValue.lockoutvalue < 1) {
  //     this.snackBar.open('Please provide a valid Lockout Duration', 'OK', { duration: 5000 });
  //     return;
  //   }

  //   if (!formValue.lockoutUnit) {
  //     this.snackBar.open('Please select Lockout Unit', 'OK', { duration: 5000 });
  //     return;
  //   }
  // }
   this.passwordPolicy = {
    ...this.passwordPolicy,
    resetlimit: formValue.resetlimit,
    lastpasswordchecking: formValue.lastpasswordchecking,
    passwrodcomparisionwithusername: formValue.passwrodcomparisionwithusername,
    duplicatepassord: formValue.duplicatepassord,
    disableallrules: formValue.disableallrules,
    lockoutenabled: formValue.lockoutenabled,
    lockoutvalue: formValue.lockoutvalue,
    lockoutUnit: formValue.lockoutUnit,
    passwordexpirycycle: formValue.passwordexpirycycle,
    companyname: formValue.companyname
  };

  if (formValue.resetlimit > 0) {
    if (!formValue.lockoutenabled) {
      this.FormValid.get('lockoutenabled')?.setErrors({ required: true });
      
    }
     if (!formValue.lockoutvalue) {
    this.FormValid.get('lockoutvalue')?.setErrors({ required: true });
  } else if (formValue.lockoutvalue < 1) {
    this.FormValid.get('lockoutvalue')?.setErrors({ min: true });
  }
    if (!formValue.lockoutUnit) {
      this.FormValid.get('lockoutUnit')?.setErrors({ required: true });
      
    }
  }
    if (this.FormValid.invalid) {
    this.FormValid.markAllAsTouched();
    this.snackBar.open("All manditory fields must be filled","Ok",{duration: 5000 })
    return;
  }
    console.log("After validation check")
    this.spinner.start()
     this.commonService.insertPasswordPolicies(this.passwordPolicy)
    .subscribe({
      next: (res) => {
        this.spinner.stop();
        this.snackBar.open('Password policy saved successfully', '', { duration: 3000 });
         this.snackBar.open(res.statusMessage, "OK", { duration: 5000 });

        // Optionally refresh data here
         this.dialogref.close();
      },
      error: (err) => {
        this.spinner.stop();
        this.snackBar.open('Failed to save password policy', '', { duration: 5000 });
        console.error(err);
      }
    });
  }
  cancel(){
    this.dialogref.close();
  }

  
  async DropdownCompany() {
    var tenantId = this.localStorageSettings.getSettings('dnsName');
    //reteriveing users by dnsId
    this.spinner.start()

    console.log('userRoleNameData');
    console.log(this.userRoleNameData);

    

    let response = await this.http.get<trnxCommonServiceInfo>(this.restAPI.GET_TRNX_TABLE_DATA_FOR_DROPDOWNS + "/" + "company" + "/" + "compname", { headers: this.headers }).toPromise();
    console.log(response)
    if (response.error == true) {

      this.spinner.stop();

      this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });

    }
    else {

      this.spinner.stop();

      this.companyData = response;



    }

  }

  companyNameChange(selectedCompany:string){
     this.FormValid.get('companyname')?.setValue(selectedCompany);

     this.passwordPolicy.companyname = selectedCompany;

     console.log("Selected company:", selectedCompany);

  }
}


